import B from './components/B';
import C from './components/C';
import D from './components/D';
import E from './components/E';
import F from './components/F';
import G from './components/G';
import H from './components/H';
import I from './components/I';
import J from './components/J';
import K from './components/K';
import { getDetaileMoreProducts } from '@/utils';
import { useGlobal } from '@/utils/useGlobal';
import OtherList from '@/components/ProductCommon/OtherList';
import ProductRecommand from '@elem/compCommon/ProductRecomand';

export default function IndexDynamic() {
    const { gloproductlist, useRouter } = useGlobal();
    const { locale } = useRouter();
    const otherProduct: any = getDetaileMoreProducts(
        gloproductlist,
        ['product_ps_river_river_256', 'product_ps_river_river_512', 'product_sp_110w_solar_panel'],
        '',
        '',
        locale === 'us' ? 'https://us.ecoflow.com/collections/solar-generators' : `https://${locale}.ecoflow.com/collections/solar-panels`,
    );
    const ALLOW_SITES = ['eu', 'uk', 'de', 'fr', 'it', 'es', 'us', 'ca', 'nl'];
    otherProduct?.items?.map((list: any, k: number) => {
        if (k === 0) {
            list.link = ALLOW_SITES.includes(locale) ? `https://${locale}.ecoflow.com/products/river-2-portable-power-station?variant=40322673410121` : '';
        }
        if (k === 1) {
            list.link = ALLOW_SITES.includes(locale) ? `https://${locale}.ecoflow.com/products/110w-portable-solar-panel?variant=39998109941833` : '';
        }
        if (k === 2) {
            list.link = ALLOW_SITES.includes(locale) ? `https://${locale}.ecoflow.com/products/160w-portable-solar-panel?variant=31913800630345` : '';
        }
    });

    const props = {
        more: `https://${locale}.ecoflow.com/collections/solar-panels`,
        data: [
            {
                productId: '9935710912788',
                variantId: '51194414924052',
            },
            {
                productId: '10080514113812',
                variantId: '51820095373588',
            },
            {
                productId: '9935698985236',
                variantId: '51194374881556',
            },
        ],
    };

    return (
        <>
            <B />
            <C />
            <D />
            <E />
            <F />
            <G />
            <H />
            <I />
            <J />
            <K />
            {['nl'].includes(locale) ? <ProductRecommand {...props} /> : <OtherList data={otherProduct} />}
        </>
    );
}
